

















































































































import { Component, Prop, Vue, Watch} from 'vue-property-decorator'
import { User } from '@/api/model/user'
import { availableDashboardViews, availableGenders, availableRoles, CredentialsType } from '@/api/types'
import moment from 'moment'
import KvButton from '@/components/input/KvButton.vue'

@Component({
    components: { KvButton },
})
export default class CreateUserForm extends Vue {
    @Prop({ required: true }) readonly value!: User
    savingAvatar: boolean = false
    birthdate: string = null
    showRelations: boolean = false
    showRealworksAccountManagerId: boolean = false

    mounted() {
        if (this.value.birthdate) {
            this.birthdate = moment(this.value.birthdate).format('DD-MM-YYYY')
        }

        if (this.$currentCompany.hasCredentialsWithType(CredentialsType.REALWORKS)) {
            this.showRelations = true
            this.showRealworksAccountManagerId = true
        }
    }

    @Watch('birthdate')
    onBirthdayChanged(): void {
        this.value.birthdate = moment(this.birthdate, 'DD-MM-YYYY').toISOString()
    }

    get roleOptions() {
        return availableRoles().map(value => ({
            label: this.$t(`role.${value}`),
            value,
        }))
    }

    get genderOptions() {
        return availableGenders().map(value => ({
            label: this.$t(`gender.${value}`),
            value,
        }))
    }

    get defaultDashboardViewOptions() {
        return availableDashboardViews().map(value => ({
            label: this.$t(`dashboard-view.${value}`),
            subtext: this.$t(`dashboard-view.${value}_subtext`),
            value,
        }))
    }

    get availableBranches() {
        return this.$currentCompany.getAvailableBranches()
    }

    get emailAlreadyInUse(): boolean {
        return this.$currentCompany.users.some((user: User) => user.email === this.value.email)
    }

    async updateAvatar(event: any): Promise<void> {
        this.value.avatar = event.target.files[0]
    }

    get avatarPreview(): string {
        if (this.value.avatar) {
            return URL.createObjectURL(this.value.avatar)
        }

        return null
    }
}
